/**
 * Polling policy for the open-invoice-payment overlay (MED-1430).
 *
 * The poll used to run at a flat 5 s for as long as the manager licence page
 * stayed open with an unfinished payment, with no attempt cap — 720 requests an
 * hour per tab from someone doing nothing. At 16 ms of server CPU per request the
 * 2026-09-24 capacity audit put roughly 1078 such idle tabs across both
 * applications at 90 percent CPU on the production server, against the 8100
 * managers it would take to do the same by actually using the dashboard.
 *
 * Each attempt now waits 1.5x longer than the last, up to a minute, and the poll
 * gives up after MAX_ATTEMPTS: about 31 minutes of foreground polling in 35
 * requests, where the flat interval would have sent 368 and then kept going.
 *
 * These four values and the curve below are deliberately identical to
 * Medecine360-ui's src/components/organisms/PaymentInProgressOverlay/polling.ts
 * (MED-1429). The two applications are separate repositories, so the curve is
 * agreed rather than shared — change both or neither.
 */
export const OPEN_PAYMENT_POLL_INTERVAL_MS = 5000;
export const OPEN_PAYMENT_POLL_BACKOFF_FACTOR = 1.5;
export const OPEN_PAYMENT_POLL_MAX_INTERVAL_MS = 60000;
export const OPEN_PAYMENT_POLL_MAX_ATTEMPTS = 35;

/** Wait before attempt `attempt` (0-based). */
export const openPaymentPollDelayMs = (attempt: number): number =>
  Math.min(
    OPEN_PAYMENT_POLL_INTERVAL_MS * OPEN_PAYMENT_POLL_BACKOFF_FACTOR ** attempt,
    OPEN_PAYMENT_POLL_MAX_INTERVAL_MS,
  );
